export const TAB_SECTION = {
  PHOTO_GALLERY: 'photoGallery',
  ITEM_DOCUMENTS: 'itemDocuments',
} as const;
